import React, { useCallback } from 'react';
import { Button } from '@crabs-ai/ds-react';
import { useFeatureEnabled } from '@/shared/hooks/useFeatureEnabled';
import { useCurrentStateAsRef } from '@/features/remotion-editor/editor/utils/use-context';
import { logEditorState } from '@/features/remotion-editor/editor/debuging-console/editor-state-console';

export default function EditorHeaderDebugItemsButton() {
  const { enable: isOperator } = useFeatureEnabled();
  const stateRef = useCurrentStateAsRef();

  const handleClick = useCallback(() => {
    const { items, tracks, assets } = stateRef.current.undoableState;
    logEditorState({ items, tracks, assets });
  }, [stateRef]);

  if (!isOperator) {
    return null;
  }

  return (
    <Button
      size="small"
      hierarchy="tertiary"
      onClick={handleClick}
      className="max-w-fit"
    >
      Debug Items
    </Button>
  );
}
